import { AudioSystemEvent } from './AudioSystem';
import AudioClip, { AudioTrackType, IAudioParams } from './AudioClip';
import Scene from '../../Scene/Scene';

export function StartAudio(
    scene: Scene,
    clip: AudioClip | string,
    type: AudioTrackType,
    params?: Partial<IAudioParams>
): AudioClip {
    let audioClip: AudioClip;

    if (clip instanceof AudioClip) {
        audioClip = clip;
    } else {
        audioClip = new AudioClip(clip, type, params);
    }

    scene.emit(AudioSystemEvent.PLAY, audioClip);

    return audioClip;
}

export function StopAudio(scene: Scene, clip: AudioClip): void {
    scene.emit(AudioSystemEvent.STOP, clip);
}
